<div class="header">
    <!-- <mat-form-field  appearance="outline" class="searchContainer2">
        <mat-label>Search</mat-label>
        <input type="text" matInput >
        <mat-icon matPrefix color="primary">search</mat-icon> 
    </mat-form-field> -->

    <div class="searchbar">
        <input class="searchInput" type="text" placeholder="Search" />
        <span class="searchIcon">
            <!-- <i class="flaticon-loupe searchIcn"></i> -->
            <img class="flaticon-loupe searchIcn" src="../../assets/images/searcgImg.svg" alt="">
            <!-- <mat-icon class="searchIcn">search</mat-icon> -->
        </span>


    </div>

    <button class="serchBtn" mat-button color="primary" (click)="editGroup()" style="height: 44px;">
        <mat-icon style="margin-right: 0.2rem;margin-bottom: 4px;">add_circle</mat-icon>
        Add Group
    </button>
</div>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
  
        <!-- Position Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element, let i = index"> 
                {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}}
            </td>
        </ng-container>
  
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        
        <!-- Program Column -->
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Active </th>
            <td mat-cell *matCellDef="let element"> {{element.active}} </td>
        </ng-container>

        <!-- Edit Button Column -->
        <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef> Edit </th>
            <td mat-cell *matCellDef="let element"> 
                <button mat-icon-button color="primary" (click)="editGroup(element)">
                    <mat-icon>create</mat-icon>
                </button>     
            </td>
        </ng-container>
  
        <!-- Delete Column -->
        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef> Delete </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" (click)="deleteGroup(element)">
                    <mat-icon>delete</mat-icon>
                </button>     
            </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  
    <mat-paginator [pageSizeOptions]="[20]" showFirstLastButtons></mat-paginator>
</div>